import dayjs from "dayjs";
import get from "lodash/get";
import React, { FC, useEffect, useLayoutEffect, useState } from "react";
import { Button, DatePicker } from "@pd/pd-ui-kit";
import { Flex } from "antd";
import { subMonths } from "date-fns";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { useDealersForSelect } from "~/entity/Dealers/hooks/useDealersForSelect";
import { onScrollBottomFamilyCar } from "~/hooks/selectCarFamily";
import { useSetSelectOption } from "~/hooks/SelectValue";
import { getSelectValues } from "~/libs/getData";
import {
  firstDayMonth,
  getLastDayOfMonth,
  lastDayMonth,
} from "~/libs/getFormatDate";
import {
  buildSrrReportVariables,
  getSelectValuesEdition,
} from "~/pages/SRR/model/buildReportVariables";
import { SRR_REPORTS_CONFIG } from "~/pages/SRR/model/reportsConfig";
import {
  SRR_GO,
  SRR_KIND_REPORT,
  SRR_KINDS,
  SRR_LOYALTY_TYPE,
  SRR_TO,
} from "~/pages/SRR/options";
import {
  DealersLocationItem,
  TypeClientReportSrr,
  TypeGoReportSrr,
  TypeToReportSrr,
  useGetDealersLocationItemQuery,
} from "~/schemas/generated/graphql";
import { useNotify } from "~/shared/hooks/useNotify";
import { filterOptionByLabel } from "~/shared/lib/filterHelpers";
import { handlePopupScrollBottom } from "~/shared/lib/handlePopupScrollBottom/handlePopupScrollBottom";
import { Field } from "~/shared/ui/Field";

import s from "./SelectDealerForm.less";
import fieldStyles from "~/shared/ui/Field/Field.less";

interface IProps {
  onSumbitTable?;
  firstSelectVal: string;
  setGroupSrr?;
  loading?;
  refetch?;
  clearTableReport?;
  reportSelect?: string;
  reportConfigData: any;
  setSearchTextForSelect: any;
  setReportConfigData: React.Dispatch<React.SetStateAction<any>>;
}

const SRRReportForm: FC<IProps> = ({
  onSumbitTable,
  setGroupSrr,
  loading,
  clearTableReport,
  refetch,
  reportSelect = "",
  reportConfigData,
  setSearchTextForSelect,
  setReportConfigData,
  firstSelectVal,
}) => {
  const { t } = useTranslation();
  const setSelectOption = useSetSelectOption();
  const language = localStorage.getItem("language");
  const isEn = language === "en";
  const [checkBtn, setCheckBtn] = useState(false);

  const arrCarModel = [
    "TOReturnCarForServiceByPeriodConsolidated",
    "TOFriendOrFoeByPeriodByCarFamily",
    "TOMonthOfControlFriendOrFoeByCarFamily",
    "ReportReturnSRR3ByCar",
    "ReportReturnSRR5ByCar",
    "ReportReturnCarAverageDailyMileageByMonth",
    "ReportNSByDealer",
    "ReportNSByConsultant",
    "ReportNSByClient",
    "ReportNSByWarmClients",
    "ReportNSByAverageCarAge",
    "ReportNSByOldClients",
    "ReportNSByClientCarSale",
    "TOMonthOfControlCarFamilyRegion",
  ];

  const arrKind = ["ReportReturnUniqueService", "ReportReturnLoyaltyService"];

  const { control, watch, handleSubmit, errors } = useForm({
    defaultValues: {
      ...reportConfigData,
      salePeriod: { value: 3, label: 3 },
      ...(reportConfigData.hasOwnProperty("salePeriodStart") &&
      reportConfigData.hasOwnProperty("salePeriodEnd")
        ? {
            salePeriodStart: reportConfigData.salePeriodStart,
            salePeriodEnd: reportConfigData.salePeriodEnd,
          }
        : {}),
      numberTOSingle: {
        label: TypeToReportSrr.To0,
        value: TypeToReportSrr.To0,
      },
    },
    // resolver: yupResolver(schema),
  });

  const resetForm = () => {
    setCheckBtn(false);
  };

  const watchGroupReport = watch("groupReport");

  const watchSalePeriodStart = watch("salePeriodStart");
  const watchSalePeriodEnd = watch("salePeriodEnd");
  const watchMethod = watch("method");
  const watchKindReport = watch("kindReport");

  const { notifyReport } = useNotify();
  const exportQueries: Record<string, (opts?: any) => void> = {};

  for (const [key, cfg] of Object.entries(SRR_REPORTS_CONFIG)) {
    const { hook, getterPath } = cfg.export;
    const [exportQuery] = hook({
      onCompleted(data: unknown) {
        const hash = get(data, `${getterPath}.fileHash`);
        hash && notifyReport(hash);
      },
      fetchPolicy: "no-cache",
    });
    exportQueries[key] = exportQuery;
  }

  const {
    options: dealershipsForSelect,
    loading: dealersLoading,
    onScrollBottom: onScrollBottomDealers,
    searchDealers: searсhDealer,
  } = useDealersForSelect();

  const familyCarForSelect = onScrollBottomFamilyCar();

  const diealerCity = useGetDealersLocationItemQuery({
    variables: {
      item: DealersLocationItem["City"],
    },
  });

  const diealerCountry = useGetDealersLocationItemQuery({
    variables: {
      item: DealersLocationItem["Country"],
    },
  });

  const diealerSubject = useGetDealersLocationItemQuery({
    variables: {
      item: DealersLocationItem["Subject"],
    },
  });

  const diealerFo = useGetDealersLocationItemQuery({
    variables: {
      item: DealersLocationItem["Fo"],
    },
  });

  const selectCity = get(
    diealerCity,
    `data.DealerGetter.getDealersLocationItem.${isEn ? "itemsEn" : "items"}`,
    [],
  ).map((el) => {
    return {
      label: el,
      value: el,
    };
  });

  const selectCountry = get(
    diealerCountry,
    `data.DealerGetter.getDealersLocationItem.${isEn ? "itemsEn" : "items"}`,
    [],
  ).map((el) => {
    return {
      label: el,
      value: el,
    };
  });
  const selectSubject = get(
    diealerSubject,
    `data.DealerGetter.getDealersLocationItem.${isEn ? "itemsEn" : "items"}`,
    [],
  ).map((el) => {
    return {
      label: el,
      value: el,
    };
  });

  const selectFo = get(
    diealerFo,
    `data.DealerGetter.getDealersLocationItem.${isEn ? "itemsEn" : "items"}`,
    [],
  ).map((el) => {
    return {
      label: el,
      value: el,
    };
  });

  const onSumbit = (data) => {
    const elem = {
      ...data,
    };
    setReportConfigData({ ...reportConfigData, ...elem });
    if (
      elem.hasOwnProperty("salePeriodStart") &&
      elem.hasOwnProperty("salePeriodEnd")
    ) {
      elem.salePeriodStart = firstDayMonth(elem.salePeriodStart);
      elem.salePeriodEnd = lastDayMonth(elem.salePeriodEnd);
    }

    clearTableReport();
    setSearchTextForSelect(reportSelect);

    const baseFrom = {
      numberTO:
        elem.numberTO && elem.numberTO.length > 0
          ? getSelectValuesEdition(elem.numberTO, TypeToReportSrr)
          : undefined,

      typeClient: elem.typeClient
        ? elem.typeClient.length > 0
          ? getSelectValuesEdition(elem.typeClient, TypeClientReportSrr)
          : undefined
        : undefined,

      // monthControl: new Date(
      //   `${elem.yearControl?.value}-${elem.monthControl?.value}-15T22:02+03:00`
      // ),

      FO:
        elem.groupReport?.value === "Fo"
          ? elem.FO
            ? elem.FO.length > 0
              ? getSelectValues(elem.FO)
              : undefined
            : undefined
          : undefined,
      City:
        elem.groupReport?.value === "City"
          ? elem.City
            ? elem.City.length > 0
              ? getSelectValues(elem.City)
              : undefined
            : undefined
          : undefined,
      Region:
        elem.groupReport?.value === "Region"
          ? elem.Region
            ? elem.Region.length > 0
              ? getSelectValues(elem.Region)
              : undefined
            : undefined
          : undefined,
      DealerIds:
        elem.groupReport?.value === "Dealer"
          ? elem.DealerIds
            ? elem.DealerIds.length > 0
              ? getSelectValues(elem.DealerIds)
              : undefined
            : undefined
          : undefined,
    };

    const reportConfig = SRR_REPORTS_CONFIG[reportSelect];

    if (checkBtn) {
      reportConfig &&
        exportQueries[reportSelect]?.({
          variables: buildSrrReportVariables(
            reportConfig.variables.excel,
            elem,
            baseFrom,
          ),
        });
    } else {
      // Отчеты где не нужны ТО по умолчанию
      const excludedReportsToTODefault = ["ReportReturnClientsWithoutService"];

      setGroupSrr({
        group:
          reportSelect === "TOMonthOfControlCarFamilyRegion"
            ? "cars"
            : elem.groupReport?.value === "FO"
              ? "FO"
              : elem.groupReport?.value.toLowerCase(),
        arrTO: elem.numberTOSingle
          ? [elem.numberTOSingle?.label]
          : elem.numberTO && elem.numberTO.length > 0
            ? getSelectValuesEdition(elem.numberTO, TypeToReportSrr)
            : reportSelect.search(/SRR[0-9]/) === -1 ||
                ["ReportReturnSRR5ByVIN"].includes(reportSelect)
              ? !excludedReportsToTODefault.includes(reportSelect) &&
                getSelectValuesEdition(
                  [SRR_TO[1], SRR_TO[2], SRR_TO[3], SRR_TO[4], SRR_TO[5]],
                  TypeToReportSrr,
                )
              : [],
        arrGO:
          elem.numberGO && elem.numberGO.length > 0
            ? getSelectValuesEdition(elem.numberGO, TypeGoReportSrr)
            : !excludedReportsToTODefault.includes(reportSelect)
              ? getSelectValuesEdition(
                  [SRR_GO[0], SRR_GO[1], SRR_GO[2]],
                  TypeGoReportSrr,
                )
              : [],
        selectCheked: reportSelect,
        monthControl: elem.monthControl
          ? `${
              elem.monthControl.getMonth() + 1
            }.${elem.monthControl.getFullYear()}`
          : undefined,
        bonus: elem.bonus ? Number(elem.bonus) : undefined,
      });
      reportConfig &&
        onSumbitTable({
          variables: buildSrrReportVariables(
            reportConfig.variables.table,
            elem,
            baseFrom,
          ),
          ...(reportConfig.tableHasRefetchOnCompleted
            ? {
                onCompleted() {
                  refetch();
                },
              }
            : {}),
        });
    }
  };
  const arrMonthControl = [
    "TOMonthOfControlMine",
    "TOMonthOfControlFriendOrFoe",
    "TOMonthOfControlFriendOrFoeByCarFamily",
    "TOMonthOfControlCarFamilyRegion",
    "warrantyRepairMonthOfControl",
    "warrantyRepairBySalesPeriod",
    "ReportReturnCarAverageDailyMileageByMonth",
    "ReportReturnSRR3ByDealer",
    "ReportReturnSRR5ByDealer",
    "ReportReturnSRR3ByVIN",
    "ReportReturnSRR5ByVIN",
    "InvitationOfClientsForMaintenance",
    "ReportReturnCarForServiceGIBDDByMonth",
    "ReportReturnCarForeignForServiceGIBDDByMonth",
    "ReportReturnSRR3GIBDDByDealer",
    "ReportReturnSRR5GIBDDByDealer",
  ];

  const arrRepairControl = [
    "ReportReturnCarServiceDynamics",
    "ReportReturnSRR3GIBDDByPeriod",
    "ReportReturnSRR5GIBDDByPeriod",
    "ReportReturnCarServiceByDealer",
    "ReportReturnClientsWithoutService",
    "ReportReturnSRR3ByPeriod",
    "ReportReturnSRR5ByPeriod",
    "ReportReturnUniqueService",
    "ReportReturnLoyaltyService",
  ];

  const arrNoTypeClient = [
    "ReportNSByDealer",
    "ReportNSByConsultant",
    "ReportNSByClient",
    "ReportNSByWarmClients",
    "ReportNSByOldClients",
    "ReportNSByClientCarSale",
    "ReportNSByAverageCarAge",

    "ReportReturnLoyaltyServiceByDealer",
  ];
  const arrNS = [
    "ReportNSByDealer",
    "ReportNSByConsultant",
    "ReportNSByClient",
    "ReportNSByWarmClients",
    "ReportNSByOldClients",
    "ReportNSByAverageCarAge",
    "ReportNSByClientCarSale",
  ];

  const isNotSRR3ByDealer =
    reportSelect !== "ReportReturnSRR3ByDealer" &&
    reportSelect !== "ReportReturnSRR3GIBDDByDealer" &&
    reportSelect !== "ReportReturnSRR5GIBDDByDealer" &&
    reportSelect !== "ReportReturnSRR5ByDealer";
  const isNotSRR3ForPayments =
    reportSelect !== "ReportReturnSRR3ForPayments" &&
    reportSelect !== "ReportReturnSRR5ForPayments" &&
    reportSelect !== "ReportReturnSRR3ByCar" &&
    reportSelect !== "ReportReturnLoyaltyServiceByDealer" &&
    reportSelect !== "ReportReturnSRR5ByCar";
  const isNotSRRByVIN = ![
    "ReportReturnSRR5ByVIN",
    "ReportReturnSRR3ByVIN",
  ].includes(reportSelect);

  const isUVIN = (elem) =>
    reportSelect === "ReportReturnUniqueService" ||
    reportSelect === "ReportReturnLoyaltyService" ||
    reportSelect === "ReportReturnLoyaltyServiceByDealer";
  // && watchKindReport?.value === elem

  const groupReportOptions: any[] = [
    "Dealer",
    "City",
    "Region",
    "Fo",
    "Country",
  ].map((option) => setSelectOption(option, "srr"));
  const numberTOSingleOptions: any[] = Object.values(TypeToReportSrr).map(
    (option) => setSelectOption(option),
  );
  const salePeriodOptions: any[] = [1, 2, 3, 4, 5, 6].map((option) =>
    setSelectOption(option),
  );
  const kindReportOptions =
    reportSelect === "ReportReturnLoyaltyService"
      ? SRR_KIND_REPORT.filter((el) => el.value !== "Kind")
      : SRR_KIND_REPORT;
  const methodOptions = [
    { value: "limit", label: "По сроку эксплуатации" },
    { value: "run", label: "По пробегу" },
  ];
  const typeClientOptions = [
    {
      value: "Legal",
      label: "Юридическое лицо",
    },
    {
      value: "Person",
      label: "Физическое лицо",
    },
  ];

  return (
    <form onSubmit={handleSubmit(onSumbit)} className={s.select_dealer_wrap}>
      <ul>
        {(["ReportReturnSRR5ByVIN", "ReportReturnSRR3ByVIN"].includes(
          reportSelect,
        ) ||
          reportSelect === "InvitationOfClientsForMaintenance" ||
          reportSelect === "ReportNSByAverageCarAge") && (
          <li>
            <Field
              type="select"
              name="dealerIds"
              control={control}
              label={t(`srr.dealerships`)}
              mode="multiple"
              labelInValue
              showSearch
              filterOption={false}
              loading={dealersLoading}
              options={dealershipsForSelect}
              onChange={() => searсhDealer("")}
              onSearch={(text) => text && searсhDealer(text)}
              onPopupScroll={handlePopupScrollBottom(onScrollBottomDealers)}
              onBlur={() => searсhDealer("")}
            />
          </li>
        )}

        {isNotSRR3ByDealer &&
          isNotSRR3ForPayments &&
          isNotSRRByVIN &&
          reportSelect !== "InvitationOfClientsForMaintenance" &&
          reportSelect !== "ReportNSByAverageCarAge" && (
            <li>
              <Field
                type="select"
                name="groupReport"
                control={control}
                label={t("srr.groupReport")}
                defaultValue={groupReportOptions[0]}
                labelInValue
                showSearch
                filterOption={filterOptionByLabel}
                options={groupReportOptions}
              />
            </li>
          )}
        {watchGroupReport?.value === "City" &&
          isNotSRR3ByDealer &&
          isNotSRR3ForPayments &&
          isNotSRRByVIN &&
          reportSelect !== "ReportNSByAverageCarAge" && (
            <li>
              <Field
                type="select"
                name="City"
                control={control}
                label={t(`srr.City`)}
                mode="multiple"
                labelInValue
                showSearch
                filterOption={filterOptionByLabel}
                options={selectCity}
              />
            </li>
          )}
        {watchGroupReport?.value === "Fo" &&
          isNotSRR3ByDealer &&
          isNotSRR3ForPayments &&
          isNotSRRByVIN && (
            <li>
              <Field
                type="select"
                name="FO"
                control={control}
                label={t(`srr.FOGroup`)}
                mode="multiple"
                labelInValue
                showSearch
                filterOption={filterOptionByLabel}
                options={selectFo}
              />
            </li>
          )}
        {watchGroupReport?.value === "Dealer" &&
          isNotSRR3ByDealer &&
          isNotSRR3ForPayments &&
          isNotSRRByVIN &&
          reportSelect !== "InvitationOfClientsForMaintenance" &&
          reportSelect !== "ReportNSByAverageCarAge" && (
            <li>
              <Field
                type="select"
                name="DealerIds"
                control={control}
                label={t("srr.DealerIds")}
                mode="multiple"
                labelInValue
                showSearch
                filterOption={false}
                loading={dealersLoading}
                options={dealershipsForSelect}
                onChange={() => searсhDealer("")}
                onSearch={(text) => text && searсhDealer(text)}
                onPopupScroll={handlePopupScrollBottom(onScrollBottomDealers)}
                onBlur={() => searсhDealer("")}
              />
            </li>
          )}
        {watchGroupReport?.value === "Region" &&
          isNotSRR3ByDealer &&
          isNotSRR3ForPayments &&
          isNotSRRByVIN && (
            <li>
              <Field
                type="select"
                name="Region"
                control={control}
                label={t(`srr.RegionGroup`)}
                mode="multiple"
                labelInValue
                showSearch
                filterOption={filterOptionByLabel}
                options={selectSubject}
              />
            </li>
          )}
        {isNotSRR3ByDealer &&
          isNotSRR3ForPayments &&
          isNotSRRByVIN &&
          !arrNS.includes(reportSelect) &&
          reportSelect !== "ReportReturnUniqueService" &&
          reportSelect !== "ReportReturnLoyaltyService" &&
          reportSelect !== "ReportReturnSRR3ByPeriod" &&
          reportSelect !== "ReportReturnSRR5ByPeriod" &&
          reportSelect !== "ReportReturnSRR3GIBDDByPeriod" &&
          reportSelect !== "ReportReturnSRR5GIBDDByPeriod" &&
          reportSelect !== "ReportReturnClientsWithoutService" &&
          reportSelect !== "ReportAverageReceiptTO" &&
          reportSelect !== "warrantyRepairMonthOfControl" &&
          reportSelect !== "warrantyRepairBySalesPeriod" &&
          reportSelect !== "InvitationOfClientsForMaintenance" &&
          reportSelect !== "ReportReturnAverageReceiptAKC" && (
            <li>
              <Field
                type="select"
                name="numberTO"
                control={control}
                label={t("srr.numberTO")}
                mode="multiple"
                labelInValue
                showSearch
                filterOption={filterOptionByLabel}
                options={SRR_TO}
              />
            </li>
          )}

        {reportSelect === "InvitationOfClientsForMaintenance" && (
          <li>
            <Field
              type="select"
              name="numberTOSingle"
              control={control}
              label={t("srr.numberTOSingle")}
              defaultValue={numberTOSingleOptions[0]}
              labelInValue
              showSearch
              filterOption={filterOptionByLabel}
              options={numberTOSingleOptions}
            />
          </li>
        )}

        {[
          "warrantyRepairMonthOfControl",
          "warrantyRepairBySalesPeriod",
        ].includes(firstSelectVal) && (
          <>
            <li>
              <Field
                type="select"
                name="numberGO"
                control={control}
                label={t("srr.numberGO")}
                mode="multiple"
                labelInValue
                showSearch
                filterOption={filterOptionByLabel}
                options={SRR_GO}
              />
            </li>
          </>
        )}

        {arrKind.includes(reportSelect) && (
          <>
            <li>
              <Field
                type="select"
                name="kindReport"
                control={control}
                label={t("srr.kindReport")}
                defaultValue={kindReportOptions[0]}
                labelInValue
                showSearch
                filterOption={filterOptionByLabel}
                options={kindReportOptions}
              />
            </li>
          </>
        )}
        {isUVIN("Kind") && (
          <>
            <li>
              <Field
                type="select"
                name="kinds"
                control={control}
                label={t("srr.kinds")}
                mode="multiple"
                labelInValue
                showSearch
                filterOption={filterOptionByLabel}
                options={SRR_KINDS}
              />
            </li>
          </>
        )}

        {((arrCarModel.includes(reportSelect) &&
          isNotSRR3ByDealer &&
          isNotSRRByVIN) ||
          isUVIN("FamilyCar")) && (
          <li>
            <Field
              type="select"
              name="CarModel"
              control={control}
              label={t("srr.CarModel")}
              error={
                arrCarModel.includes(reportSelect)
                  ? (errors.CarModel as any)?.message
                  : undefined
              }
              mode="multiple"
              labelInValue
              showSearch
              filterOption={false}
              loading={dealersLoading}
              options={familyCarForSelect.familyCarForSelect}
              onChange={() => familyCarForSelect["searchFamilyCar"]("")}
              onSearch={(text) =>
                text && familyCarForSelect["searchFamilyCar"](text)
              }
              onPopupScroll={handlePopupScrollBottom(
                familyCarForSelect["introspectionHandler"],
              )}
              onBlur={() => familyCarForSelect["searchFamilyCar"]("")}
            />
          </li>
        )}
        {arrMonthControl.includes(reportSelect) &&
          isNotSRR3ByDealer &&
          isNotSRR3ForPayments &&
          isNotSRRByVIN &&
          reportSelect !== "InvitationOfClientsForMaintenance" && (
            <li>
              <Field
                type="select"
                name="salePeriod"
                control={control}
                label={t("srr.salePeriod")}
                defaultValue={salePeriodOptions[0]}
                labelInValue
                showSearch
                filterOption={filterOptionByLabel}
                options={salePeriodOptions}
              />
            </li>
          )}

        {reportSelect === "InvitationOfClientsForMaintenance" && (
          <>
            <li>
              <Field
                type="select"
                name="method"
                control={control}
                label={t("srr.method")}
                defaultValue={methodOptions[0]}
                labelInValue
                showSearch
                filterOption={filterOptionByLabel}
                options={methodOptions}
              />
            </li>
          </>
        )}
        {arrMonthControl.includes(reportSelect) && isNotSRR3ForPayments && (
          <li>
            <Controller
              control={control}
              name={"monthControl"}
              defaultValue={null}
              render={({ value, onChange }) => (
                <div className={fieldStyles.field}>
                  <span className={fieldStyles.fieldLabel}>
                    {t("srr.monthControl")}
                  </span>
                  <DatePicker
                    picker="month"
                    format="MM.YYYY"
                    style={{ width: "100%" }}
                    value={value ? dayjs(value) : null}
                    onChange={(d) =>
                      onChange(d ? getLastDayOfMonth(d.toDate()) : null)
                    }
                    disabledDate={(current) =>
                      current &&
                      current.isBefore(dayjs(new Date("01.01.2010")), "month")
                    }
                  />
                </div>
              )}
            />
          </li>
        )}
        {!arrMonthControl.includes(reportSelect) &&
          isNotSRR3ByDealer &&
          isNotSRRByVIN && (
            <>
              <li>
                <Controller
                  control={control}
                  name={"salePeriodStart"}
                  defaultValue={null}
                  render={({ value, onChange }) => (
                    <div className={fieldStyles.field}>
                      <span className={fieldStyles.fieldLabel}>
                        {arrRepairControl.includes(reportSelect)
                          ? t("srr.periodStart")
                          : t("srr.salePeriodStart")}
                      </span>
                      <DatePicker
                        picker="month"
                        format="MM.YYYY"
                        style={{ width: "100%" }}
                        value={value ? dayjs(value) : null}
                        onChange={(d) =>
                          onChange(d ? getLastDayOfMonth(d.toDate()) : null)
                        }
                        disabledDate={(current) =>
                          current &&
                          current.isBefore(
                            dayjs(new Date("31.01.2010")),
                            "month",
                          )
                        }
                      />
                    </div>
                  )}
                />
              </li>

              <li>
                <Controller
                  control={control}
                  name={"salePeriodEnd"}
                  defaultValue={null}
                  render={({ value, onChange }) => (
                    <div className={fieldStyles.field}>
                      <span className={fieldStyles.fieldLabel}>
                        {arrRepairControl.includes(reportSelect)
                          ? t("srr.periodEnd")
                          : t("srr.salePeriodEnd")}
                      </span>
                      <DatePicker
                        picker="month"
                        format="MM.YYYY"
                        style={{ width: "100%" }}
                        value={value ? dayjs(value) : null}
                        onChange={(d) =>
                          onChange(d ? getLastDayOfMonth(d.toDate()) : null)
                        }
                        disabledDate={(current) =>
                          current &&
                          current.isBefore(
                            dayjs(
                              getLastDayOfMonth(
                                subMonths(new Date(watchSalePeriodStart), 1),
                              ),
                            ),
                            "month",
                          )
                        }
                      />
                    </div>
                  )}
                />
              </li>
            </>
          )}
        {!arrNoTypeClient.includes(reportSelect) &&
          reportSelect !== "ReportAverageReceiptTO" &&
          reportSelect !== "ReportReturnAverageReceiptAKC" && (
            <li>
              <Field
                type="select"
                name="typeClient"
                control={control}
                label={t("srr.typeClient")}
                mode="multiple"
                labelInValue
                showSearch
                filterOption={filterOptionByLabel}
                options={typeClientOptions}
              />
            </li>
          )}
        {arrNS.includes(reportSelect) && (
          <>
            {reportSelect !== "ReportNSByAverageCarAge" && (
              <>
                <li>
                  <Field
                    type="input"
                    name="NOP"
                    control={control}
                    label={t("srr.NOP")}
                  />
                </li>
                <li>
                  <Field
                    type="input"
                    name="RMP"
                    control={control}
                    label={t("srr.RMP")}
                  />
                </li>
              </>
            )}
            {reportSelect === "ReportNSByDealer" && (
              <>
                <li>
                  <Field
                    type="input"
                    name="bonus"
                    control={control}
                    label={t("srr.bonus")}
                    inputType="number"
                    min={1}
                  />
                </li>

                <li>
                  <Field
                    type="input"
                    name="monthControlNs"
                    control={control}
                    label={t("srr.monthControlNs")}
                    inputType="number"
                    min={1}
                    max={60}
                    step={1}
                  />
                </li>
              </>
            )}
            {reportSelect !== "ReportNSByAverageCarAge" && (
              <li>
                <Field
                  type="select"
                  name="loyaltyType"
                  control={control}
                  label={t("srr.loyaltyType")}
                  defaultValue={SRR_LOYALTY_TYPE[0]}
                  labelInValue
                  showSearch
                  filterOption={filterOptionByLabel}
                  options={SRR_LOYALTY_TYPE}
                />
              </li>
            )}
          </>
        )}
      </ul>

      <Flex justify={"flex-end"} gap={10} className={s.buttons}>
        <Button
          size={"large"}
          fontSize={"14"}
          htmlType="submit"
          color={"secondary"}
          // loading={loading}
          onClick={() => setCheckBtn(true)}
        >
          {t("editorQ.save_excel")}
        </Button>

        <Button
          size={"large"}
          fontSize={"14"}
          htmlType="submit"
          loading={loading}
          onClick={resetForm}
        >
          {t("regMen.btnTable")}
        </Button>
      </Flex>
    </form>
  );
};
export default SRRReportForm;
